<template>
  <div>
    <user-warning-message :users="warningMessages"/>
    <div class="columns is-multiline">
      <div class="column is-12">
        <caracteristique :produit="produit" :sousProduit="sousProduit"></caracteristique>
      </div>
      <div class="column is-6">
        <dates :produit="sousProduit"></dates>
      </div>
      <div class="column is-6" v-if="modulePresseActive && produit.produitPresse">
        <format-produit-presse :produit="sousProduit"></format-produit-presse>
      </div>
      <div class="column is-6">
        <div class="card height-100">
          <header class="header-card">
            <p>
              {{ $t('detailCatalogue.comptabilite.title') }}
            </p>
          </header>
          <div class="card-content columns">
            <schema-comptable
              :objetAvecSchemaComptable="produit"
              :isConsultation="true"
              class="column is-8">
            </schema-comptable>
            <detail-compte-analytique
              :produit="produit"
              class="column is-4">
            </detail-compte-analytique>
          </div>
        </div>
      </div>
      <div class="column is-6" v-if="modulePresseActive">
        <div class="card ">
          <header class="header-card">
            <p>{{ $t('detailProduitSalon.marche.title') }}</p>
          </header>
          <div class="card-content">
            <marche :produit="produit" class="mgb-10px" detail></marche>
            <regle-facturation :produit="produit"></regle-facturation>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="card height-100">
          <header class="header-card">
            <p>{{ $t('detailProduitSalon.commentaire.title') }}</p>
          </header>
          <div class="card-content">
            <p class="has-text-default is-italic">
              {{ $t('detailProduitSalon.commentaire.field') }}
            </p>
            <p class="has-text-weight-bold">{{ produit.commentaire }}</p>
          </div>
        </div>
      </div>
      <div class="column is-6" v-if="modulePresseActive && produit.produitPresse">
        <div class="card height-100">
          <header class="header-card">
            <p>{{ $t('detailProduitPresse.prestationGracieuse.title') }}</p>
          </header>
          <div class="card-content">
            <p class="has-text-default is-italic">
              {{ $t('detailProduitPresse.prestationGracieuse.field') }}
            </p>
            <p class="has-text-weight-bold">{{ produit.prestationGracieuse }}</p>
          </div>
        </div>
      </div>
      <produit-commentaire-vente-card
        :produit="produit"
        class="column is-6"
        isDetail/>
      <div class="column is-12 mgt-10px">
        <div class="card  ">
          <header class="header-card">
            <p>{{ $t('produitSalon.pj.title')}}</p>
          </header>
          <div class="card-content">
            <pieces-jointes :checkPermissions="true" readOnly deletable autoSave
                            :canAddPj="!produitWithHolding"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import caracteristique from '@/components/catalogue/produitGeneralPresse/detail/caracteristique';
import piecesJointes from '@/components/general/piecesJointes';
import schemaComptable from '@/components/general/schemaComptable';
import dates from '@/components/catalogue/produitGeneralPresse/detail/dates';
import { siteHasHolding } from '@/services/general/holding';
import regleFacturation from '@/components/catalogue/produitGeneralPresse/detail/regleFacturation';
import detailCompteAnalytique from '@/components/catalogue/produitGeneral/compteAnalytique/detailCompteAnalytique';
import produitCommentaireVenteCard from '@/components/catalogue/produitGeneral/produitCommentaireVenteCard';
import marche from '@/components/catalogue/produitGeneralPresse/edition/marche';
import userWarningMessage from '@/components/commun/user/userWarningMessage';
import messageErreur from '@/services/general/messageErreur';
import formatProduitPresse
  from '@/components/catalogue/produitGeneralPresse/detail/formatProduitPresse';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'm_produitinformation',
  props: {
    produit: {
      type: Object,
      required: true,
    },
    sousProduit: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    modulePresseActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    produitWithHolding() {
      return (siteHasHolding() && this.produit
        && this.produit.supportCommercial.societeId !== this.societeActiveId);
    },
    warningMessages() {
      return [
        {
          id: this.produit.assistantId,
          msg: 'utilisateur.warning.assistantArchive',
        },
        ...this.produit.objectifsVente.map(o => ({
          id: o.commercialId,
          msg: 'utilisateur.warning.commercialArchive',
        })),
        ...this.produit.commissionsVendeur.map(c => ({
          id: c.commercialId,
          msg: 'utilisateur.warning.commercialArchive',
        })),
      ];
    },
  },
  components: {
    caracteristique,
    piecesJointes,
    schemaComptable,
    regleFacturation,
    formatProduitPresse,
    dates,
    detailCompteAnalytique,
    marche,
    userWarningMessage,
    produitCommentaireVenteCard,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    try {
      await this.loadParametresInterne([typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
